import { navigate } from "gatsby";
import React from "react";
import { Dropdown } from "react-bootstrap";

const SearchFlyer = ({ facets, querydata }) => {
  return (
    <Dropdown.Menu className="dropdown-menu full-width-dropdown-menu dropdown-menu-end">
      <div className="fwdm-head d-flex justify-content-between align-items-center">
        <h3>{querydata}</h3>
        <h3
          className="aviation-parts-search"
          onClick={() => {
            navigate(`/aviation-parts/?filter=${querydata}`);
          }}
        >
          Search "{querydata}" in Aviation Parts
        </h3>
      </div>
      <div className="fwdm-body" data-simplebar>
        <div className="fwdm-inner-content d-flex flex-wrap">
          <div className="fwdm-box">
            <h4>Search in Category</h4>
            <ul className="fwdm-list">
              {Object?.keys(facets)?.length > 0 &&
                facets.hasOwnProperty("categories.lvl0") &&
                Object?.keys(facets["categories.lvl0"]).map((ecat) => (
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();

                        ecat == "Pipe"
                          ? navigate(`/pipe/?q=${querydata}`)
                          : navigate(`/search/?category=${ecat}&q=${querydata}`);
                      }}
                    >
                      {ecat?.split("_")[0]} ({facets["categories.lvl0"][ecat]})
                    </a>
                  </li>
                ))}
            </ul>
          </div>
          <div className="fwdm-box">
            <h4>Search in Region</h4>
            <ul className="fwdm-list">
              {Object?.keys(facets)?.length > 0 &&
                facets.hasOwnProperty("region") &&
                Object?.keys(facets["region"]).map((ecat) => (
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/search/?region=${ecat}&q=${querydata}`);
                      }}
                    >
                      {ecat} ({facets["region"][ecat]})
                    </a>
                  </li>
                ))}
            </ul>
          </div>
          <div className="fwdm-box">
            <h4>Search in Manufacturer</h4>
            <ul className="fwdm-list">
              {Object?.keys(facets)?.length > 0 &&
                facets.hasOwnProperty("make") &&
                Object?.keys(facets["make"]).map((ecat) => (
                  <li>
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/search/?mfr=${ecat}&q=${querydata}`);
                      }}
                    >
                      {ecat} ({facets["make"][ecat]})
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </Dropdown.Menu>
  );
};

export default SearchFlyer;
